import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=e2c0466e&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=e2c0466e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c0466e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2c0466e')) {
      api.createRecord('e2c0466e', component.options)
    } else {
      api.reload('e2c0466e', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=e2c0466e&scoped=true&", function () {
      api.rerender('e2c0466e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8kD9KJrWUUtqS/JS/comp/PopupDialog.vue"
export default component.exports